<template>
    <el-drawer
        title="编辑收货信息"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                v-if="formData"
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
            >
                <el-form-item prop="customerName" label="收货人姓名:" :rules="[{ required: true, message: '请输入收货人姓名' }]">
                    <el-input v-model.trim="formData.customerName" placeholder="请输入收货人姓名" maxlength="20"
                        size="medium"></el-input>
                </el-form-item>
                <el-form-item prop="telephone" label="联系手机:" :rules="[{ required: true, message: '请输入联系手机' }]">
                    <el-input v-model.trim="formData.telephone" placeholder="请输入联系手机"
                        maxlength="20" size="medium">
                        <el-select v-model="formData.areaCode" slot="prepend" placeholder="请选择区号">
                            <el-option v-for="(item, index) in countryList" :key="index" :label="`+${item.code}`"
                                :value="item.codeView">
                                +{{ item.code }} {{ item.name }}
                            </el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item prop="city" label="收货省市:" :rules="[{ required: true, message: '请选择收货省份城市' }]">
                    <el-cascader v-model="formData.city" :options="cityList" filterable
                        :props="{ label: 'name', children: 'cityList', value: 'name' }" size="medium" style="width:100%"
                        ref="cityCascader" @change="changeCity">
                    </el-cascader>
                </el-form-item>
                <el-form-item prop="address" label="收货地址:" :rules="[{ required: true, message: '请输入收货地址' }]">
                    <el-input v-model.trim="formData.address" placeholder="请输入收货地址" maxlength="100"
                        size="medium"></el-input>
                </el-form-item>
                <el-form-item v-if="formData.expressId" prop="expressId" label="快递公司:" :rules="[{ required: true, message: '请输入快递公司' }]">
                    <el-select v-model="formData.expressId" size="medium" placeholder="请选择快递公司">
                        <el-option v-for="(item, index) in expressList" :key="index" :value="item.expressId"
                            :label="item.expressName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="formData.expressNo" prop="expressNo" label="运单号:" :rules="[{ required: true, message: '请输入运单号' }]">
                    <el-input v-model.trim="formData.expressNo" placeholder="请输入运单号" maxlength="40"
                        size="medium"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确定</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
import { fetchExpress, fetchAllCity, fetchAllCountry } from '@/assets/js/commonApi';
export default {
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            formData: null,

            expressList: [],//所有快递
            cityList: [],//所有省份城市集合
            countryList: [],//所有国家集合

            rules:{
                
            },
        }
    },
    created() {
        this.getExpressList();
        this.getCityList();
        this.getCountryList();
    },
    methods:{
        //获取快递公司
        getExpressList() {
            fetchExpress().then((res) => {
                const { state, result } = res.data;
                if (state == 1) {
                    this.expressList = result;
                }
            }).catch(() => { })
        },
        //获取所有城市
        async getCityList() {
            const res = await fetchAllCity({}).catch(() => { });
            const { state, result } = res.data;
            if (state == 1) {
                this.cityList = result;
            }
        },
        //获取所有国家（区号）
        async getCountryList() {
            const res = await fetchAllCountry({}).catch(() => { });
            const { state, result } = res.data;
            if (state == 1) {
                this.countryList = result;
            }
        },
        //选择城市
        changeCity(value) {
            this.formData.provinceName = value ? value[0] : '';
            this.formData.cityName = value ? value[1] : '';
        },
        close(){
            this.formData = null;
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show(data){			
            this.formData = {
                customerName: data.receiptName || '',
                areaCode:data.areaCode || '86_CN',
                telephone: data.receipetTel || '',
                address: data.address || '',
                expressId:data.expressId || '',
                expressNo:data.expressNo || '',
                provinceName: data.provinceName || '北京',
                cityName: data.cityName || '北京',
                city: [data.provinceName || '北京',data.cityName || '北京'],
                orderId: data.orderId || '',
            };
            this.drawerShow = true;
            this.$nextTick(() => {
                this.$refs.formData.clearValidate();
            });
        },
        
        submitForm(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: "/goodOrder/saveOrderAddr",
                        method: "POST",
                        data: {...this.formData,telephone:this.formData.telephone},
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        }
    }
}
</script>